import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { downloadFile } from '@/utils/helper';
import { $file, $http } from '@/axios';
import store from '@/store';

// 查询模块列表
export const queryFurBlocks: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFurBlocks', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/asset/block/pagelist', payload);
    commit('setFurBlocks', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setFurBlocks', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询模块详情
export const queryFurBlockDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setFurBlockDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/block/${payload}/detail`);
    commit('setFurBlockDetail', { data: res, loading: false });
  } catch (e) {
    commit('setFurBlockDetail', { data: null, loading: false });
  }
};

// 查询模板列表列表
export const queryFurBlockMods: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setFurBlockMods', { data: [], loading: true });
    const res = await $http.post('/v1/data/asset/block/blockmods');
    commit('setFurBlockMods', { data: res, loading: false });
  } catch (e) {
    commit('setFurBlockMods', { data: [], loading: false });
  }
};

// 查询模块组装类型列表
export const queryFurBlockStructs: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setFurBlockStructs', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/ModuleStructureType');
    commit('setFurBlockStructs', { data: res });
  } catch (e) {
    commit('setFurBlockStructs', { data: [] });
  }
};

// 查询摆放轴列表
export const queryFurBlockAxis: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setFurBlockAxis', { ...state.blockAxes, loading: true });
    const res = await $http.get('/common/chooseoptions/Axis');
    commit('setFurBlockAxis', { data: res });
  } catch (e) {
    commit('setFurBlockAxis', { data: [] });
  }
};

// 查询模块状态列表
export const queryFurBlockStatuses: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setFurBlockStatuses', { data: [], loading: true });
    const res: any[] = await $http.get('/common/chooseoptions/ModuleItemStatus');
    const data =  [{ optionKey: '', optionValue: '全部' } , ...res];
    commit('setFurBlockStatuses', { data });
  } catch (e) {
    commit('setFurBlockStatuses', { data: [] });
  }
};

// 查询控制件组装位置列表
export const queryFurCompLocations: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setFurCompLocations', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/componentLocatingType');
    commit('setFurCompLocations', { data: res });
  } catch (e) {
    commit('setFurCompLocations', { data: [] });
  }
};

// 编辑模块基本信息
export const editFurBlock: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/block/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除模块
export const deleteFurBlock: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/v1/asset/block/delete', payload); // 删除
    await $http.post('v1/asset/block/resetcreated', payload); // 将入库状态还原为新建状态
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上下架模块
export const shelfFurBlock: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/block/publish', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 刷新模块索引
export const refreshFurBlockIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/item/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新模块缩略图
export const updateFurBlockThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setFurBlockThumb', { ...state.thumb, loading: true });
    const res = await $http.post('/v1/asset/block/modifyimg', payload);
    commit('setFurBlockThumb', { data: res, loading: false });
  } catch (e) {
    commit('setFurBlockThumb', { data: null, loading: false });
  }
};

// 更新模块颜色信息
export const updateFurBlockColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  await $http.post('/v1/asset/block/modifycolor', payload);
  store.commit('common/setToast', { visible: true, text: '颜色保存成功' });
};

// 新增价格(预留，暂时没接口)
export const addFurComponentPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 编辑价格(预留，暂时没接口)
export const editFurComponentPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出模块价格
export const exportFurBlockPrice: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setModalLoading', true);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/data/asset/block/exportprice', payload);
    downloadFile(res.blob, '家具模块价格列表');
  } finally {
    commit('setModalLoading', false);
  }
};

// 导入价格
export const importFurComponentPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { type, file } = payload;
    const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('/v1/asset/item/importprice', formData);
    store.commit('common/setToast', { visible: true, text: '价格导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出关键字(预留，暂时没接口)
export const exportFurComponentKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    const res: { blob: Blob; filename: string } = await $file.post('', payload);
    downloadFile(res.blob, '模块关键字列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入关键字
export const importFurComponentKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { file } = payload;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    await $http.post('/v1/asset/item/inputkeywords', formData);
    store.commit('common/setToast', { visible: true, text: '关键字导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 删除模块过滤项配置
export const deleteFurBlockFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/block/filterdelete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存模块过滤项配置
export const saveFurBlockFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/block/filterbatchmodify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } catch (e) {
    return;
  }
};
